import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import GoogleLogin from 'react-google-login'
import DocumentTitle from 'react-document-title'
import AppleLogin from 'react-apple-login'
import { signup, login, externalLogin } from '../../actions/session'
import SignupForm from '../../components/forms/SignupForm'
import CartoonDevice from '../../components/misc/CartoonDevice'
import Icon from '../../components/misc/Icons'
import getErrorMessageForRequest from '../../utils/getErrorMessageForRequest'

const responseGoogle = (/* response */) => {}

class SignUpWithGoogleBtn extends React.PureComponent {
  render() {
    return (
      <GoogleLogin
        clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
        onSuccess={this.props.googleLogin}
        onFailure={responseGoogle}
        className="signup-continueWithGoogleBtn signup-continueWithGoogleBtn--default"
        type="submit"
      >
        <div className="signup-continueWithGoogleBtn-centerContent">
          <div className="signup-continueWithGoogleBtn-centerContent-icon">
            <Icon name="googleLogoSignInColor" />
            <Icon name="googleLogoSignInGray" />
          </div>
          <div className="signup-continueWithGoogleBtn-centerContent-label">
            Continue with Google
          </div>
        </div>
      </GoogleLogin>
    )
  }
}

class SignInWithAppleBtn extends React.Component {
  render() {
    return (
      <button
        onClick={this.props.appleLogin}
        className="signup-signInWithAppleBtn"
      >
        <div className="signup-signInWithAppleBtn-centerContent">
          <div className="signup-signInWithAppleBtn-centerContent-icon">
            <Icon name="appleSignInLogo" />
          </div>
          <div className="signup-signInWithAppleBtn-centerContent-label">
            Sign in with Apple
          </div>
        </div>
      </button>
    )
  }
}

class SignupContainer extends Component {
  constructor() {
    super()
    this.handleSignup = this.handleSignup.bind(this)
    this.goToLogin = this.goToLogin.bind(this)
    this.onPreSubmit = this.onPreSubmit.bind(this)
    this.googleLogin = this.googleLogin.bind(this)
    this.appleCallback = this.appleCallback.bind(this)
    this.state = {
      errorMessage: null,
      submitLoading: false,
    }
  }

  componentDidMount() {
    const elements = document.getElementsByClassName('signup-continueWithGoogleBtn signup-continueWithGoogleBtn--default')
    // Clean this up
    /* eslint-disable */
    const googleButton = ReactDOM.findDOMNode(elements[0])
    /* eslint-enable */
    if (googleButton) {
      googleButton.tabIndex = '1'
      setTimeout(() => {
        googleButton.focus()
      }, 500)
    }
  }

  appleCallback(data) {
    if (data.authorization) {
      const token = data.authorization.id_token
      const requestData = {
        type: 'apple',
        idToken: token,
        firstName: '-',
        lastName: '-',
      }
      if (data.user) {
        requestData.firstName = data.user.name.firstName
        requestData.lastName = data.user.name.lastName
      }
      this.props.externalLogin(requestData).then(() => {})
    }
  }

  onPreSubmit() {
    this.setState({ submitLoading: true })
  }

  handleSignup(data) {
    const { signup, login } = this.props
    this.setState({ errorMessage: null })
    signup(this.appendData(data))
      .then(() => {
        // Once signed up log user in
        const loginData = {
          email: data.email,
          password: data.password,
        }
        return login(loginData)
      })
      .catch((error) => {
        this.setState({ submitLoading: false })
        const errorMessage = getErrorMessageForRequest({
          requestName: 'signup',
          response: error.response,
          data: { email: data.email },
        })
        this.setState({ errorMessage })
      })
  }

  googleLogin(googleUser) {
    this.setState({ submitLoading: true })
    const requestData = {
      type: 'google',
      idToken: googleUser.tokenId,
    }
    this.props.externalLogin(requestData).then(() => {
      const authInstance = window.gapi.auth2.getAuthInstance()
      authInstance.disconnect()
    })
  }

  goToLogin() {
    this.props.history.push('login')
  }

  appendData = (data) => {
    const nowDate = new Date()
    return {
      ...data,
      clientModified: nowDate,
      userCreated: nowDate,
      title: '',
    }
  }

  render() {
    return (
      <DocumentTitle title="Create Account - Plickers">
        <div className="signup marketing notranslate">
          <div className="signup-centerBlock">
            <div className="signup-centerBlock--top">
              <div className="signup-centerBlock-logoSpacer-top" />
              <div className="signup-centerBlock-logo">
                <Icon name="logo" />
              </div>
              <div className="signup-centerBlock-logoSpacer-bottom" />
            </div>
            <div className="signup-centerBlock--middle">
              <div className="signup-centerBlock-title">
                Sign up for free
              </div>
              <div className="signup-centerBlock-spacer" />

              <div className="signup-centerBlock-divider">
                <div className="signup-centerBlock-divider-line" />
                <div className="signup-centerBlock-divider-label">
                  or use email and password
                </div>
                <div className="signup-centerBlock-divider-line" />

              </div>

              <SignupForm
                onPreSubmit={this.onPreSubmit}
                onSubmit={this.handleSignup}
                signupError={this.state.errorMessage}
                submitLoading={this.state.submitLoading}
              />
              <div className="signup-thirdPartyBtnContainer">
                <SignUpWithGoogleBtn googleLogin={this.googleLogin} />
                <AppleLogin
                  clientId={process.env.REACT_APP_SIGN_IN_WITH_APPLE_CLIENT_ID}
                  redirectURI={process.env.REACT_APP_SIGN_IN_WITH_APPLE_REDIRECT_URI}
                  usePopup
                  callback={this.appleCallback}
                  scope="email name"
                  responseType="query"
                  render={(props) => (<SignInWithAppleBtn appleLogin={props.onClick} />)}
                />
              </div>
            </div>

            <div className="signup-centerBlock--bottom">
              <div className="signup-centerBlock-goToLoginBtn" onClick={this.goToLogin}>
                If you already have an account, click here to sign in
              </div>
            </div>

          </div>

          <div className="signup-deviceArray">
            <div className="signup-deviceArray-topLeft">
              <CartoonDevice device="laptop" screen="laptopSetEditor" />
            </div>
            <div className="signup-deviceArray-topRight">
              <CartoonDevice device="iPhone" screen="iPhoneNowPlayingReview" />
            </div>
            <div className="signup-deviceArray-bottomRight">
              <CartoonDevice device="laptop" screen="laptopSetEditor" />
            </div>
            <div className="signup-deviceArray-bottomLeft">
              <CartoonDevice device="iPhone" screen="iPhoneNowPlayingReview" />
            </div>
          </div>

        </div>
      </DocumentTitle>
    )
  }
}

export default withRouter(connect(
  (/* state */) => ({ }),
  { signup, login, externalLogin },
)(SignupContainer))
